import { useEffect, useMemo, useState } from 'react';
import {
  Button,
  Center,
  Loader,
  LoadingOverlay,
  MultiSelect,
  NumberInput,
  Text as MantineText,
  TextInput,
  Space,
} from '@mantine/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { IconFileDescription, IconFileExport } from '@tabler/icons';
import { DataS } from '../../Service/DataS';
import { useEventKinds } from '../../Service/hooks/useEventKinds';
import BookingState from '../../Types/Enums/BookingState';
import { DocumentS } from './DocumentS';

export const openExportDocumentsModal = () =>
  openModal({
    title: (
      <MantineText weight="bolder" size="xl">
        Dokumente exportieren
      </MantineText>
    ),
    children: <ExportDocumentsModal />,
  });

export const ExportDocumentsModal = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const [filename, setFilename] = useState(`Dokumente-${currentYear}`);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState<number | undefined>(currentYear);
  const [bookingStates, setBookingStates] = useState<string[]>([BookingState.BOOKED]);
  const [documentTypes, setDocumentTypes] = useState<string[]>(['INVOICE']);
  const [eventKinds, setEventKinds] = useState<string[]>([]);
  const { loading: eventKindsLoading, kinds } = useEventKinds();

  useEffect(() => {
    setFilename(`Dokumente-${year}`);
  }, [year]);

  const onClick = async () => {
    setLoading(true);
    await DocumentS.exportDocumentsCSV(filename, year, eventKinds, bookingStates, documentTypes);
    setLoading(false);
    closeAllModals();
  };

  return (
    <>
      <LoadingOverlay visible={loading} />
      <NumberInput label="Jahr" value={year} onChange={setYear} mb="sm" />
      <MultiSelect
        mb="sm"
        label="Dokument-Art"
        value={documentTypes}
        data={DataS.getDocumentTypeOptions()}
        onChange={setDocumentTypes}
      />
      <MultiSelect
        my="sm"
        label="Buchungsstatus"
        value={bookingStates}
        data={DataS.getBookingStateOptions()}
        onChange={setBookingStates}
      />
      <MultiSelect
        mb="sm"
        label="Event-Arten"
        searchable
        placeholder="Suchen"
        disabled={eventKindsLoading}
        value={eventKinds}
        data={kinds.map((k) => ({ value: k.name, label: k.name }))}
        onChange={setEventKinds}
        icon={eventKindsLoading ? <Loader size="xs" /> : undefined}
      />
      <TextInput
        label="Dateiname"
        value={filename}
        icon={<IconFileDescription size={20} />}
        onChange={(e) => setFilename(e.target.value)}
        rightSection={
          <MantineText size="xs" weight="bolder">
            CSV
          </MantineText>
        }
      />
      <Space h="xl" />
      <Center>
        <Button
          mt="xl"
          sx={{ width: 200 }}
          onClick={onClick}
          leftIcon={<IconFileExport size={20} />}
          disabled={filename === ''}
        >
          Export
        </Button>
      </Center>
    </>
  );
};
